module.exports = __webpack_public_path__ + "065fd957643b4e7e32b4e0e612983625.png";